const SHIMMER_BAR_CLASS =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse";

const HEADER_INFO_ITEMS = ["date", "time", "property", "room"];
const QA_ITEM_COUNT = 6;

const ViewingQADrawerShimmer = () => {
  return (
    <div className="flex flex-col gap-6 py-3 px-4.5 h-full">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <div className={`w-[18px] h-[18px] ${SHIMMER_BAR_CLASS}`} />
          <div className={`h-4 w-[260px] ${SHIMMER_BAR_CLASS}`} />
        </div>
        <div
          className={`w-[16px] h-[16px] rounded-full ${SHIMMER_BAR_CLASS}`}
        />
      </div>

      <div className="flex gap-4 items-center p-3 rounded-lg border border-border-gray dark:border-border-gray-dk border-l-[6px] bg-pure-white dark:bg-pure-white-dk">
        {HEADER_INFO_ITEMS.map((key, index) => (
          <div key={key} className="flex items-center gap-4 flex-1 min-w-0">
            {index > 0 && (
              <div className="w-px h-[19px] border-l border-border-gray dark:border-border-gray-dk shrink-0" />
            )}
            <div className="flex flex-col gap-1.5 flex-1 min-w-0">
              <div className={`h-3 w-16 ${SHIMMER_BAR_CLASS}`} />
              <div className="flex items-center gap-1.5">
                <div className={`w-[16px] h-[16px] shrink-0 ${SHIMMER_BAR_CLASS}`} />
                <div className={`h-3.5 w-full max-w-[120px] ${SHIMMER_BAR_CLASS}`} />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-col gap-3.5 h-full overflow-hidden">
        {Array.from({ length: QA_ITEM_COUNT }).map((_, index) => (
          <div key={`qa-shimmer-${index}`} className="flex flex-col gap-2">
            <div className={`h-3.5 w-2/3 ${SHIMMER_BAR_CLASS}`} />
            <div
              className={`h-[36px] w-full rounded-lg ${SHIMMER_BAR_CLASS}`}
            />
          </div>
        ))}
      </div>

      <div className="flex justify-between items-center">
        <div className={`h-7 w-[170px] rounded-lg ${SHIMMER_BAR_CLASS}`} />
        <div className="flex gap-2">
          <div className={`h-7 w-[80px] rounded-lg ${SHIMMER_BAR_CLASS}`} />
          <div className={`h-7 w-[80px] rounded-lg ${SHIMMER_BAR_CLASS}`} />
        </div>
      </div>
    </div>
  );
};

export default ViewingQADrawerShimmer;
